var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLabel)?_c('tr-text',_vm._b({staticClass:"label",attrs:{"tracker":_vm.tracker},on:{"edit-tr":function($event){return _vm.$emit('edit-tr', $event)}}},'tr-text',_vm.props.label,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }